<nb-accordion class="mt-3">
  <nb-accordion-item>
    <nb-accordion-item-header class="d-flex align-items-center">
      <div class="flex-grow-1" i18n>Action {{ aci + 1 }}</div>
      <button class="mr-5" nbButton status="danger" size="small" (click)="removeAction.emit({ ai, aci })">
        <nb-icon icon="trash-2-outline"></nb-icon>
      </button>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <div [formGroup]="group">
        <div class="row">
          <div class="col">
            <div class="field-label" i18n>Action Type<span style="color: red">*</span></div>
            <nb-select class="w-100" formControlName="action_type">
              <nb-option *ngFor="let t of actionTypes" [value]="t">{{ t }}</nb-option>
            </nb-select>
          </div>
          <div class="col">
            <div class="field-label" i18n>Action Value</div>
            <input class="w-100" nbInput formControlName="action_value" />
          </div>
        </div>

        <div class="row mt-3">
          <div class="field-label" i18n>
            Action Payload
            <hr />
          </div>
          <div formGroupName="action_payload">
            <div class="row">
              <div class="col-6">
                <div class="field-label" i18n>URL</div>
                <input class="w-100" nbInput formControlName="url" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
